function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import omit from 'object.omit';
import { format as formatDate } from 'date-fns';
import VDatePicker from '@cloud-sn/v-datepicker';
import { isEqual } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
import localeCN from './locale/zh_CN';
import Icon from '../icon';
export default {
  name: buildComponentName('WeekPicker'),
  props: _objectSpread({}, omit(VDatePicker.props, ['mode', 'isOpen', 'showTime', 'showToday', 'showOk', 'showDateInput', 'dateInputPlaceholder', 'disabledTime', 'okConfirm', 'showWeekNumber']), {
    prefixCls: {
      type: String,
      default: 'ux-calendar'
    },
    locale: {
      type: Object,
      default: function _default() {
        return localeCN.lang;
      }
    },
    value: {
      type: Date,
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'default',
      validator: function validator(value) {
        return ['small', 'large', 'default'].indexOf(value) > -1;
      }
    }
  }),
  data: function data() {
    return {
      innerValue: null
    };
  },
  computed: {
    pickerClasses: function pickerClasses() {
      var _ref;

      var prefixCls = this.prefixCls,
          theme = this.theme,
          size = this.size;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-picker"), true), _defineProperty(_ref, "".concat(prefixCls, "-picker-").concat(theme), true), _defineProperty(_ref, "".concat(prefixCls, "-picker-").concat(size), true), _ref;
    },
    pickerInputClass: function pickerInputClass() {
      var _ref2;

      var prefixCls = this.prefixCls,
          disabled = this.disabled,
          size = this.size;
      var inputPrefix = 'ux-input';
      var map = {
        small: 'sm',
        large: 'lg'
      };
      return _ref2 = {}, _defineProperty(_ref2, inputPrefix, true), _defineProperty(_ref2, "".concat(prefixCls, "-picker-input"), true), _defineProperty(_ref2, "".concat(inputPrefix, "-disabled"), disabled), _defineProperty(_ref2, "".concat(inputPrefix, "-").concat(map[size]), size !== 'default'), _ref2;
    },
    normalizeLocale: function normalizeLocale() {
      var locale = this.locale;

      if (!locale) {
        return localeCN.lang;
      }

      return locale.lang ? locale.lang : locale;
    },
    dateFormat: function dateFormat() {
      var normalizeLocale = this.normalizeLocale,
          format = this.format;
      return format || normalizeLocale.weekFormat || 'YYYY 第 WW 周';
    },
    formatValue: function formatValue() {
      var innerValue = this.innerValue,
          dateFormat = this.dateFormat;

      if (!innerValue) {
        return '';
      }

      return formatDate(innerValue, dateFormat);
    },
    dateInputPlaceholder: function dateInputPlaceholder() {
      var normalizeLocale = this.normalizeLocale,
          placeholder = this.placeholder;
      return placeholder || normalizeLocale.weekPlaceholder;
    },
    isCanClear: function isCanClear() {
      var disabled = this.disabled,
          allowClear = this.allowClear,
          innerValue = this.innerValue;
      return !disabled && allowClear && innerValue;
    }
  },
  watch: {
    value: function value(nVal) {
      this.setInnerValue(nVal, false);
    }
  },
  created: function created() {
    var value = this.value,
        setInnerValue = this.setInnerValue;
    setInnerValue(value, false);
  },
  methods: {
    setInnerValue: function setInnerValue(value) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var innerValue = this.innerValue,
          dateFormat = this.dateFormat;
      this.innerValue = value;

      if (trigger && !isEqual(innerValue, value)) {
        this.$emit('input', value);
        this.$emit('change', value, value ? formatDate(value, dateFormat) : '');
      }
    },
    onClearClick: function onClearClick(e) {
      e.stopPropagation();
      e.preventDefault();
      this.setInnerValue(null);
    },
    onChange: function onChange(value) {
      this.setInnerValue(value);
    }
  },
  render: function render() {
    var h = arguments[0];
    var $props = this.$props,
        $listeners = this.$listeners,
        prefixCls = this.prefixCls,
        pickerClasses = this.pickerClasses,
        pickerInputClass = this.pickerInputClass,
        innerValue = this.innerValue,
        formatValue = this.formatValue,
        dateFormat = this.dateFormat,
        dateInputPlaceholder = this.dateInputPlaceholder,
        disabled = this.disabled,
        isCanClear = this.isCanClear,
        visible = this.visible,
        normalizeLocale = this.normalizeLocale,
        onClearClick = this.onClearClick,
        onChange = this.onChange;

    var pickerProps = _objectSpread({}, omit($props, ['value', 'format', 'placeholder', 'allowClear']), {
      pickerPrefixCls: "".concat(prefixCls, "-picker-container"),
      value: innerValue,
      isOpen: visible,
      format: dateFormat,
      showWeekNumber: true,
      showTime: false,
      showToday: false,
      showDateInput: false,
      locale: normalizeLocale
    });

    var on = _objectSpread({}, omit($listeners, ['change']), {
      change: onChange
    });

    return h(VDatePicker, {
      "props": _objectSpread({}, pickerProps),
      "on": _objectSpread({}, on)
    }, [h("div", {
      "class": pickerClasses,
      "slot": "trigger"
    }, [h("input", {
      "class": pickerInputClass,
      "domProps": {
        "value": formatValue
      },
      "attrs": {
        "placeholder": dateInputPlaceholder,
        "disabled": disabled,
        "type": "text",
        "readonly": true
      }
    }), isCanClear ? h(Icon, {
      "class": "".concat(prefixCls, "-picker-clear"),
      "attrs": {
        "type": "close_circle"
      },
      "on": {
        "click": onClearClick
      }
    }) : null, h("span", {
      "class": "".concat(prefixCls, "-picker-icon")
    })])]);
  }
};